import { c as _c } from "react/compiler-runtime";
import { Logo } from '@shared/utils/icons';
import { type ReactNode } from 'react';
type Props = {
  children: ReactNode;
};
const EmbedLayout = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  const appUrl = process.env.NEXT_PUBLIC_SITE_URL || "https://factiii.com";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-4 flex justify-center"><a href={appUrl} target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" aria-label="Visit on Factiii"><Logo height={69} rounded={true} /></a></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className="flex-1 overflow-auto pb-16"><div className="w-full">{children}</div></div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute inset-x-0 bottom-0 z-50 m-8 rounded-md border bg-background-secondary p-4"><div className="flex items-center justify-between"><a href={appUrl} target="_blank" rel="noopener noreferrer" className="text-sm text-textSecondary transition-colors hover:text-primary" aria-label="Explore Factiii">Explore Factiii</a><a href={appUrl} target="_blank" rel="noopener noreferrer" className="text-sm text-textSecondary transition-colors hover:text-primary" aria-label="Visit this page">Visit this page</a></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className="relative flex max-h-[500px] max-w-xl flex-col overflow-hidden rounded-lg border border-ds-border-standard p-4 shadow-md" id="main-embed" aria-label="Embedded content from Factiii"><div className="flex min-h-0 flex-1 flex-col">{t1}{t2}{t3}</div></div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default EmbedLayout;